import { render, staticRenderFns } from "./DinamicsPayments.vue?vue&type=template&id=278996c4&"
import script from "./DinamicsPayments.vue?vue&type=script&lang=ts&"
export * from "./DinamicsPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports